// مدل منوی مبتنی بر دسترسی (AP-008): آیتم بدون Permission پنهان؛ آیتم با Feature غیرفعال با نشان «نیازمند ارتقا»
// و لینک اشتراک نمایش داده می‌شود (نه پنهان — AC-PLT-031.2).
import type { ComponentType } from 'react';

export interface MenuItemDefinition {
  id: string;
  /** کلید i18n در فضای نام ماژول، مثل plt:menu.branches. */
  labelKey: string;
  path: string;
  icon?: ComponentType;
  /** Permission لازم ({ctx}.{resource}.{action})؛ بدون آن همه کاربران مستأجر می‌بینند. */
  permission?: string;
  /** هر یک از این Permissionها کافی است (گروه‌ها). */
  anyPermission?: readonly string[];
  /** Feature لازم (feature.{ctx}.{name})؛ غیرفعال ← UpgradeBadge. */
  feature?: string;
  /** Console: یکی از نقش‌های پلتفرم (Realm Role platform-*). */
  platformRoles?: readonly string[];
  children?: readonly MenuItemDefinition[];
}

export interface ResolvedMenuItem extends Omit<MenuItemDefinition, 'children'> {
  /** Feature غیرفعال: نمایش با UpgradeBadge و لینک به upgradePath. */
  requiresUpgrade: boolean;
  children?: ResolvedMenuItem[];
}

export interface MenuAccess {
  can: (permission: string) => boolean;
  featureEnabled: (feature: string) => boolean;
  hasPlatformRole?: (roles: readonly string[]) => boolean;
}

function isVisible(item: MenuItemDefinition, access: MenuAccess): boolean {
  if (item.permission && !access.can(item.permission)) {
    return false;
  }
  if (item.anyPermission && !item.anyPermission.some((p) => access.can(p))) {
    return false;
  }
  if (item.platformRoles && !(access.hasPlatformRole?.(item.platformRoles) ?? false)) {
    return false;
  }
  return true;
}

/** فیلتر و علامت‌گذاری منو بر پایه دسترسی مؤثر (me/access). گروه بدون فرزند قابل‌مشاهده پنهان می‌شود. */
export function resolveMenu(items: readonly MenuItemDefinition[], access: MenuAccess): ResolvedMenuItem[] {
  const resolved: ResolvedMenuItem[] = [];
  for (const item of items) {
    if (!isVisible(item, access)) {
      continue;
    }
    const { children, ...rest } = item;
    const requiresUpgrade = item.feature ? !access.featureEnabled(item.feature) : false;
    if (children) {
      const visibleChildren = resolveMenu(children, access);
      if (visibleChildren.length === 0) {
        continue;
      }
      resolved.push({ ...rest, requiresUpgrade, children: visibleChildren });
    } else {
      resolved.push({ ...rest, requiresUpgrade });
    }
  }
  return resolved;
}
